(function () {
  var root = document.querySelector('[data-ghost-shield]');
  if (!root) return;

  var scope = document.body;

  function parsePlanId(raw) {
    var id = Number(String(raw == null ? '' : raw).trim());
    if (!id || id < 1) return 0;
    return id;
  }

  function hideNode(node) {
    if (!node || node.nodeType !== 1) return;
    node.style.setProperty('display', 'none', 'important');
    node.setAttribute('aria-hidden', 'true');
  }

  function hideWidgetAndParents(node) {
    if (!node || node.closest('[data-ghost-shield]')) return;
    if (node.closest('.appstle_sub_widget') || node.closest('[class*="appstle_"]')) return;

    hideNode(node);

    var block = node.closest('[id^="shopify-block-"]')
      || node.closest('.shopify-block')
      || node.closest('.shopify-app-block');
    hideNode(block);
  }

  function concealAppstleWidget() {
    var nodes = scope.querySelectorAll('.appstle_sub_widget, .appstle-tootltip-parent');
    nodes.forEach(function (node) {
      node.setAttribute('aria-hidden', 'true');
      node.querySelectorAll('a, button, input, select, textarea').forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
    });
  }

  function hideShopifySubscriptionsWidgets() {
    var nodes = scope.querySelectorAll([
      '[class*="shopify_subscriptions"]',
      '[id*="shopify_subscriptions"]',
      '.shopify_subscriptions_app_block',
      '.shopify_subscriptions_app_block_container'
    ].join(','));

    nodes.forEach(hideWidgetAndParents);
  }

  function planIdFromInput(input) {
    if (!input) return 0;
    return parsePlanId(input.getAttribute('data-appstle-real-value') || input.value);
  }

  function getAppstleSellingPlanId() {
    var widget = scope.querySelector('.appstle_sub_widget');
    if (!widget) return 0;

    var checked = widget.querySelector('input[name="selling_plan"]:checked');
    var fromChecked = planIdFromInput(checked);
    if (fromChecked) return fromChecked;

    return parsePlanId(widget.getAttribute('data-selected-selling-plan'));
  }

  function selectAppstleSubscription(useClick) {
    var widget = scope.querySelector('.appstle_sub_widget');
    if (!widget) return 0;

    var subscribe = null;
    var oneTime = null;
    var inputs = widget.querySelectorAll('input[name="selling_plan"]');
    for (var i = 0; i < inputs.length; i++) {
      if (planIdFromInput(inputs[i])) {
        subscribe = inputs[i];
      } else {
        oneTime = inputs[i];
      }
    }
    if (!subscribe) return 0;

    if (useClick) {
      var label = widget.querySelector('label[for="' + subscribe.id + '"]');
      if (label) {
        label.click();
      } else {
        subscribe.click();
      }
    }

    if (oneTime) {
      oneTime.checked = false;
      oneTime.removeAttribute('checked');
      var oneTimeOption = oneTime.closest('.appstle_subscription_wrapper_option');
      if (oneTimeOption) {
        oneTimeOption.classList.remove('appstle_selected_background', 'appstle-active-option');
      }
    }

    subscribe.disabled = false;
    subscribe.checked = true;
    subscribe.setAttribute('checked', 'checked');

    var option = subscribe.closest('.appstle_subscription_wrapper_option');
    if (option) {
      option.classList.add('appstle_selected_background', 'appstle-active-option');
    }

    var planId = planIdFromInput(subscribe);
    if (planId) {
      widget.setAttribute('data-selected-selling-plan', String(planId));
    }
    return planId;
  }

  function defaultAppstleSubscribeOnce() {
    if (getAppstleSellingPlanId()) return true;
    var widget = scope.querySelector('.appstle_sub_widget');
    if (!widget) return false;
    if (!widget.querySelector('input[name="selling_plan"]')) return false;
    selectAppstleSubscription(false);
    return !!getAppstleSellingPlanId();
  }

  function syncMountVariant(variantId) {
    var mountForm = root.querySelector('.ghost-shield__appstle-form');
    if (!mountForm || !variantId) return;
    var idInput = mountForm.querySelector('[name="id"]');
    if (idInput) idInput.value = String(variantId);
  }

  function syncCardPlanFields() {
    root.querySelectorAll('[data-ghost-shield-plan]').forEach(function (card) {
      var planId = String(card.getAttribute('data-selling-plan-id') || '').trim();
      if (!planId || Number(planId) < 1) return;

      card.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
        input.value = planId;
        input.setAttribute('value', planId);
      });

      var purchaseType = card.querySelector('input[name="purchaseType"]');
      if (purchaseType) {
        purchaseType.value = 'autorenew';
      }
    });
  }

  hideShopifySubscriptionsWidgets();
  syncCardPlanFields();
  defaultAppstleSubscribeOnce();
  concealAppstleWidget();

  var mountForm = root.querySelector('.ghost-shield__appstle-form');
  if (mountForm) {
    mountForm.addEventListener('submit', function (event) {
      event.preventDefault();
    });
  }

  var observer = new MutationObserver(function () {
    hideShopifySubscriptionsWidgets();
    concealAppstleWidget();
  });
  observer.observe(scope, { childList: true, subtree: true });

  document.addEventListener('AppstleSubscription:SubscriptionWidget:widgetInitialised', function () {
    hideShopifySubscriptionsWidgets();
    defaultAppstleSubscribeOnce();
    concealAppstleWidget();
  });
  document.addEventListener('AppstleSubscription:SubscriptionWidget:SubscriptionWidgetUpdated', function () {
    hideShopifySubscriptionsWidgets();
    defaultAppstleSubscribeOnce();
    concealAppstleWidget();
  });

  function initStarterPopup() {
    var popup = document.querySelector('[data-ghost-shield-starter-popup]');
    if (!popup) return null;

    var overlay = popup.querySelector('[data-starter-popup-overlay]');
    var dialog = popup.querySelector('[data-starter-popup-dialog]');
    var form = popup.querySelector('[data-starter-popup-form]');
    var formState = popup.querySelector('[data-starter-popup-form-state]');
    var thanksState = popup.querySelector('[data-starter-popup-thanks]');
    var nameInput = popup.querySelector('[data-starter-popup-name]');
    var emailInput = popup.querySelector('[data-starter-popup-email]');
    var nameError = popup.querySelector('[data-starter-popup-name-error]');
    var emailError = popup.querySelector('[data-starter-popup-email-error]');
    var formError = popup.querySelector('[data-starter-popup-form-error]');
    var submitButton = popup.querySelector('[data-starter-popup-submit]');
    var closeButtons = popup.querySelectorAll('[data-starter-popup-close], [data-starter-popup-done]');
    var webhookUrl = (popup.getAttribute('data-webhook-url') || '').trim();
    var webhookKey = (popup.getAttribute('data-webhook-key') || '').trim();
    var errorName = popup.getAttribute('data-error-name') || 'Please enter your first name.';
    var errorEmail = popup.getAttribute('data-error-email') || 'Please enter your email address.';
    var errorEmailInvalid = popup.getAttribute('data-error-email-invalid') || 'Please enter a valid email address.';
    var errorSubmit = popup.getAttribute('data-error-submit') || 'We could not start your free plan. Please try again.';
    var storageKey = 'ghost-shield-starter-lead';
    var lastFocus = null;
    var focus = window.GhostModalFocus;

    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
    }

    function setError(input, errorNode, message) {
      if (!errorNode) return;
      if (message) {
        errorNode.textContent = message;
        errorNode.hidden = false;
        if (input) input.setAttribute('aria-invalid', 'true');
        return;
      }
      errorNode.textContent = '';
      errorNode.hidden = true;
      if (input) input.removeAttribute('aria-invalid');
    }

    function hasStoredLead() {
      try {
        return window.localStorage.getItem(storageKey) === '1';
      } catch (error) {
        return false;
      }
    }

    function storeLead() {
      try {
        window.localStorage.setItem(storageKey, '1');
      } catch (error) {}
    }

    function showThanks() {
      if (formState) formState.hidden = true;
      if (thanksState) thanksState.hidden = false;
    }

    function showForm() {
      if (formState) formState.hidden = false;
      if (thanksState) thanksState.hidden = true;
    }

    function getFocusable() {
      if (!dialog) return [];
      return Array.prototype.slice.call(
        dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')
      ).filter(function (node) {
        return node.offsetParent !== null || node === document.activeElement;
      });
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup();
        return;
      }
      if (event.key !== 'Tab' || !dialog) return;
      var nodes = getFocusable();
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
        return;
      }
      if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function openPopup() {
      if (!overlay) return;
      popup.hidden = false;
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('ghost-shield-starter-open');
      lastFocus = document.activeElement;

      if (hasStoredLead()) {
        showThanks();
      } else {
        showForm();
        if (form) form.reset();
        setError(nameInput, nameError, '');
        setError(emailInput, emailError, '');
        if (formError) {
          formError.hidden = true;
          formError.textContent = '';
        }
      }

      if (focus) {
        focus.rememberFocus();
        focus.focusInitial(dialog, '[data-starter-popup-close]');
      } else if (hasStoredLead() === false && nameInput) {
        nameInput.focus();
      } else {
        var closeBtn = popup.querySelector('[data-starter-popup-close]');
        if (closeBtn) closeBtn.focus();
      }

      document.addEventListener('keydown', onKeydown);
    }

    function closePopup() {
      if (!overlay) return;
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      popup.hidden = true;
      document.documentElement.classList.remove('ghost-shield-starter-open');
      document.removeEventListener('keydown', onKeydown);
      if (focus && focus.restoreFocus) {
        focus.restoreFocus();
      } else if (lastFocus && lastFocus.focus) {
        lastFocus.focus();
      }
    }

    function sendLead(name, email) {
      if (!webhookUrl) {
        return Promise.reject(new Error(errorSubmit));
      }
      if (!webhookKey) {
        return Promise.reject(new Error(errorSubmit));
      }

      return fetch(webhookUrl, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'X-ZGS-Starter-Key': webhookKey
        },
        body: JSON.stringify({
          name: name,
          email: email
        })
      }).then(function (response) {
        return response.text().then(function (text) {
          var data = {};
          if (text) {
            try {
              data = JSON.parse(text);
            } catch (error) {
              data = {};
            }
          }
          if (response.ok) {
            return data;
          }
          var message = data.error || data.message || errorSubmit;
          throw new Error(message);
        });
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var name = nameInput ? nameInput.value.trim() : '';
        var email = emailInput ? emailInput.value.trim() : '';
        var valid = true;

        if (!name) {
          setError(nameInput, nameError, errorName);
          valid = false;
        } else {
          setError(nameInput, nameError, '');
        }

        if (!email) {
          setError(emailInput, emailError, errorEmail);
          valid = false;
        } else if (!isValidEmail(email)) {
          setError(emailInput, emailError, errorEmailInvalid);
          valid = false;
        } else {
          setError(emailInput, emailError, '');
        }

        if (!valid) {
          if (!name && nameInput) nameInput.focus();
          else if (emailInput) emailInput.focus();
          return;
        }

        if (submitButton) submitButton.disabled = true;
        if (formError) {
          formError.hidden = true;
          formError.textContent = '';
        }

        sendLead(name, email)
          .then(function () {
            storeLead();
            showThanks();
          })
          .catch(function (error) {
            if (formError) {
              formError.textContent = (error && error.message) || errorSubmit;
              formError.hidden = false;
            }
          })
          .finally(function () {
            if (submitButton) submitButton.disabled = false;
          });
      });
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        closePopup();
      });
    });

    if (overlay) {
      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) closePopup();
      });
    }

    return {
      open: openPopup,
      close: closePopup
    };
  }

  var starterPopup = initStarterPopup();

  root.addEventListener('click', function (event) {
    var button = event.target.closest('.ghost-shield__card-select');
    if (!button || button.disabled) return;

    var card = button.closest('[data-ghost-shield-plan]');
    var form = button.closest('form.ghost-shield__card-form');
    if (!card || !form) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (starterPopup) {
      if (card.getAttribute('data-one-time') === 'true') {
        starterPopup.open();
        return;
      }
      if (card.classList.contains('tier-starter')) {
        starterPopup.open();
        return;
      }
    }

    var variantId = Number(card.getAttribute('data-variant-id') || 0);
    var oneTime = card.getAttribute('data-one-time') === 'true';
    var sellingPlanId = getAppstleSellingPlanId()
      || Number(card.getAttribute('data-selling-plan-id') || 0);

    if (!variantId) return;
    if (!oneTime) {
      if (sellingPlanId < 1) return;
      syncMountVariant(variantId);
      selectAppstleSubscription(true);
      sellingPlanId = getAppstleSellingPlanId()
        || Number(card.getAttribute('data-selling-plan-id') || 0);
      if (sellingPlanId < 1) return;
    }

    if (!oneTime) {
      if (mountForm) {
        mountForm.setAttribute('data-selling-plan', String(sellingPlanId));
        var planInput = mountForm.querySelector('input[name="selling_plan"]');
        if (!planInput) {
          planInput = document.createElement('input');
          planInput.type = 'hidden';
          planInput.name = 'selling_plan';
          mountForm.appendChild(planInput);
        }
        planInput.value = String(sellingPlanId);
        planInput.setAttribute('value', String(sellingPlanId));
      }
    }

    var errorNode = form.querySelector('.ghost-product-form__error');
    if (errorNode) {
      errorNode.hidden = true;
      errorNode.textContent = '';
    }

    var originalLabel = button.innerHTML;
    button.disabled = true;

    var addPromise;
    if (oneTime) {
      if (typeof window.GhostAddToCartFromForm === 'function') {
        addPromise = window.GhostAddToCartFromForm(form);
      } else if (typeof window.GhostAddToCart === 'function') {
        addPromise = window.GhostAddToCart([{ id: variantId, quantity: 1, one_time: true }]);
      } else {
        addPromise = Promise.reject(new Error('Unable to add product to cart.'));
      }
    } else if (typeof window.GhostAddToCartFromForm === 'function' && mountForm) {
      addPromise = window.GhostAddToCartFromForm(mountForm);
    } else if (typeof window.GhostAddToCart === 'function') {
      addPromise = window.GhostAddToCart([{ id: variantId, quantity: 1, selling_plan: sellingPlanId }]);
    } else {
      addPromise = Promise.reject(new Error('Unable to add product to cart.'));
    }

    addPromise
      .catch(function (error) {
        if (errorNode) {
          errorNode.hidden = false;
          errorNode.textContent = error.message || (card.getAttribute('data-subscription-error') || 'Unable to add product to cart.');
        }
      })
      .finally(function () {
        button.disabled = false;
        button.innerHTML = originalLabel;
      });
  }, true);

  var subscribeTimer = window.setInterval(function () {
    defaultAppstleSubscribeOnce();
  }, 350);
  window.setTimeout(function () {
    window.clearInterval(subscribeTimer);
  }, 6000);
})();
